import { TextButton } from 'react-common'
import { useTranslation } from 'react-i18next'
import { ButtonContainer } from './ButtonContainer/ButtonContainer'

export const AlreadySelfEnrolledIndicator = () => {
  const { t } = useTranslation()

  return (
    <ButtonContainer>
      <TextButton data-qa="already-enrolled-course-button" leftIcon="CheckBoldStroke" size="large" disabled>
        {t('courseDetails.enrolled')}
      </TextButton>
    </ButtonContainer>
  )
}
